import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = { class: "text-body-5 desktop:gap-2 desktop:mt-12 mt-16 flex list-disc flex-col py-4 pl-20 text-gray-800" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = ["innerHTML"];
import { computed } from 'vue';
import { I18nInfo } from '@/user/models/i18n-info';
import { parseCurrency } from '@/user/helpers/util';
import moment from 'moment';
import clsx from 'clsx';
import { FilledButton, Modal, ModalFooter } from '@/user/components/common';
import MonthlyExam from '@/user/models/certification/monthly-exam';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CertificationApplySuccessModal',
    props: {
        modelValue: { type: Boolean },
        exam: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => {
                emit('update:modelValue', value);
                if (!value) {
                    window.location.reload();
                }
            },
        });
        const commonI18n = new I18nInfo('common.button');
        const i18n = new I18nInfo('certification.testApply.modal');
        const testDate = moment(props.exam.startAt).format('YYYY-MM-DD HH:mm');
        const showDiscountCode = () => {
            if (props.exam.discountCode) {
                return `(${i18n.translate('discount.code')}: ${props.exam.discountCode})`;
            }
            return '';
        };
        const styles = {
            wrapper: 'space-y-40',
            group: 'flex flex-col gap-40',
            titleDesc: 'block text-title-2',
            note: 'text-body-5 text-gray-800',
            tableCover: 'w-full border-1 border-gray-250 rounded-12 overflow-hidden',
            table: 'w-full [&>tbody>tr:first-child>td]:border-t-0 [&>tbody>tr:first-child>th]:border-t-0',
            th: clsx('w-110 px-16 py-16 text-m-body-1 bg-gray-150 text-left border-gray-250 border-t-1', ' desktop:w-168 desktop:px-23 desktop:text-body-3'),
            td: clsx('px-15 py-17 border-gray-200 border-t-1 text-body-5', ' desktop:px-24 desktop:text-body-4'),
            inputTd: clsx('py-6 px-16 border-gray-200 border-t-1', ' desktop:py-8'),
            inputTd2: clsx('flex items-center gap-8', ' desktop:gap-10'),
            required: 'text-body-3 text-red-700',
            checkboxGroup: clsx('flex flex-col gap-8 py-20 border-t-1 border-gray-250', ' desktop:gap-0'),
            checkboxItem: 'flex items-center justify-between py-4',
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isOpen).value = $event)),
                size: "large",
                title: _unref(i18n).translate('successTitle'),
                "vertical-align": "mobileTop"
            }, {
                content: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(styles.wrapper)
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(styles.group)
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.tableCover)
                            }, [
                                _createElementVNode("table", {
                                    class: _normalizeClass(styles.table)
                                }, [
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th),
                                                innerHTML: _unref(i18n).translate('testName')
                                            }, null, 10, _hoisted_1),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td),
                                                innerHTML: props.exam.title
                                            }, null, 10, _hoisted_2)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th),
                                                innerHTML: _unref(i18n).translate('testDate')
                                            }, null, 10, _hoisted_3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td),
                                                innerHTML: _unref(testDate)
                                            }, null, 10, _hoisted_4)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th),
                                                innerHTML: _unref(i18n).translate('testTime')
                                            }, null, 10, _hoisted_5),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td),
                                                innerHTML: `${props.exam.examTime}${_unref(i18n).translate('timeUnit')}`
                                            }, null, 10, _hoisted_6)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th),
                                                innerHTML: _unref(i18n).translate('testMethod')
                                            }, null, 10, _hoisted_7),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td),
                                                innerHTML: _unref(i18n).translate(`testMethodValue.${props.exam.method}`)
                                            }, null, 10, _hoisted_8)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th),
                                                innerHTML: _unref(i18n).translate('testAmount')
                                            }, null, 10, _hoisted_9),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td),
                                                innerHTML: `${_unref(parseCurrency)(props.exam.amount)}${showDiscountCode()}${_unref(i18n).translate('includeVAT')}`
                                            }, null, 10, _hoisted_10)
                                        ])
                                    ])
                                ], 2)
                            ], 2),
                            _createElementVNode("div", null, [
                                _createElementVNode("strong", {
                                    class: _normalizeClass(styles.titleDesc)
                                }, _toDisplayString(_unref(i18n).translate('note.title')), 3),
                                _createElementVNode("ul", _hoisted_11, [
                                    _createElementVNode("li", {
                                        class: "desktop:py-1 py-3",
                                        innerHTML: _unref(i18n).translate('note.desc1')
                                    }, null, 8, _hoisted_12),
                                    _createElementVNode("li", {
                                        class: "desktop:py-1 py-3",
                                        innerHTML: _unref(i18n).translate('note.desc2')
                                    }, null, 8, _hoisted_13),
                                    _createElementVNode("li", {
                                        class: "desktop:py-1 py-3",
                                        innerHTML: _unref(i18n).translate('note.desc3')
                                    }, null, 8, _hoisted_14)
                                ])
                            ])
                        ], 2)
                    ], 2)
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(ModalFooter), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(FilledButton), {
                                class: "desktop:w-auto w-full",
                                color: "blue",
                                "desktop-size": "large",
                                "mobile-size": "medium",
                                onClick: _cache[0] || (_cache[0] = ($event) => (isOpen.value = false))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(commonI18n).translate('confirm')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue", "title"]));
        };
    }
});
